import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const STreeWithRenderBody = styled.div`
  .ant-collapse-item {
    .ant-collapse-header {
      height: 50px;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      align-items: center;

      .ant-collapse-expand-icon {
        width: 24px;
        height: 24px;
        padding-inline-end: 0;
        margin-inline-start: 0;
        justify-content: center;
      }
      
      .ant-collapse-header-text {
        font-family: 'Roboto';
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: ${themeColors.character.title85};
      }
    }

    .ant-collapse-item {
      .ant-collapse-header {
        padding-left: 20px;
      }

      .ant-collapse-item {
        .ant-collapse-header {
          padding-left: 40px;
        }

        .ant-collapse-item {
          .ant-collapse-header {
            padding-left: 60px;
          }

          .ant-collapse-item {
            .ant-collapse-header {
              padding-left: 80px;
            }

            .ant-collapse-item {
              .ant-collapse-header {
                padding-left: 100px;
              }
            }
          }
        }
      }
    }
    
    .ant-collapse-content-box {
      padding: 0;
      padding-block: 0 !important;
    }
  }
`;

export const SSpinArea = styled.div`
  display: block;
  width: 100%;
  height: 100px;
`;
